<template>
    <div :id="target" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                  <h5 class="modal-title">{{ isCopy ? 'Event Create a Copy' : 'Event Type Modal' }}</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <basic-input :vertical="true" :label="eventIdLabel" rule="required minMax:6:6" v-model="view.eventId" :disabled="isCopy || !isCreatModal"/>
                                    <basic-input v-if="isCopy" :vertical="true" label="New Event Id" rule="required minMax:6:6" v-model="newEventId" />
                                    <basic-input label="Event Name" type="text" :vertical="true" v-model="eventTypeData.eventNm" rule="required max:100"/>
                                    <select2 :vertical="true" :options="clientCdOptions" v-model="eventTypeData.clientCd" label="Client Code" :label-col-size="5" rule="required"/>
                                    <select2 :vertical="true" :options="notiCateCdOptions" v-model="eventTypeData.notiCateCd" label="Notification Category Code" :label-col-size="5" rule="required"/>
                                    <select2 :vertical="true" :options="notiTypeCdOptions" v-model="eventTypeData.notiTypeCd" label="Notification Type Code" :label-col-size="5" rule="required"/>
                                    <select2 :vertical="true" :options="parameterCountOptions" v-model="eventTypeData.paramCnt" label="Parameter Count" :label-col-size="5" rule="required"/>
                                    <select2 :vertical="true" :options="queueTypeOptions" v-model="eventTypeData.queueType" :default-option="false" label="Queue Type" :label-col-size="5" rule="required"/>
                                    <basic-switch :vertical="true" label="User Id Required" v-model="eventTypeData.usrYn" class="form-group"/>
                                    <basic-switch :vertical="true" label="Customer No Required" v-model="eventTypeData.custYn" class="form-group"/>
                                    <basic-switch :vertical="true" label="Show Notification Center" v-model="eventTypeData.notiCenterYn" class="form-group"/>
                                    <basic-switch :vertical="true" label="Add Subject Parameter" v-model="eventTypeData.addParamSubjYn" class="form-group"/>
                                    <select2 v-if="eventTypeData.addParamSubjYn === 'Y'" :vertical="true" :options="parameterSubjectCountOptions" v-model="eventTypeData.paramSubjectCnt" label="Parameter Subject Count" :label-col-size="5" rule="required"/>
                                    <button class="btn bg-ums" style="width: 100%" @click="send" v-if="hasRole($const.ROLES.EVENT_SAVE)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicInput from "@/components/form/input/BasicInput";
    import Select2 from "@/components/form/select/Select2";
    import validation from "@/config/mixin/validation";
    import api from '@/api/template'
    import BasicSwitch from "@/components/form/switch/BasicSwitch";
    export default {
        name: "EventTypeModal",
        components: {
            BasicSwitch,
            BasicInput,
            Select2,
        },
        mixins:[validation],
        props: {
            target: {
                type:String,
                required: true
            },
            value: {
                type:Object
            },
            isCopy: {
                type: Boolean,
                default: false
          }
        },
        data() {
            return {
                view: {
                    eventId: '',
                },
                eventTypeData:{
                    eventId:'',
                    fromEventId: '', // only copy event modal
                    eventNm:'',
                    clientCd: 'hobis',
                    usrYn: 'N',
                    custYn: 'N',
                    notiCenterYn:'N',
                    notiCateCd:'',
                    notiTypeCd:'0',
                    queueType: 'R',
                    addParamSubjYn:'N'
                },
                isCreatModal: true,
                checkItems:[],
                modalWidth: window.innerWidth - 500,
                modalHeight: window.innerHeight - 150,
            }
        },
        created() {
            window.addEventListener('resize', () => {
                this.resizeHandler()
            });
        },
        mounted() {
        },
        computed: {
            newEventId: { // only copy event modal
                get: function () {
                    return this.eventTypeData.eventId
                },
                set: function (newValue) {
                    this.eventTypeData.eventId = newValue
                }
            },
            eventIdLabel: function () {
                return `${this.isCopy ? 'Original ' : ''}Event Id`
            },
            clientCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            },
            notiTypeCdOptions: function () {
                return this.$store.getters[this.$const.GETTERS.NOTI_TYPE_CD_OPTIONS]()
            },
            notiCateCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.NOTI_CATE_CD_OPTIONS]()
            },
            parameterCountOptions: function() {
                return this.$store.getters[this.$const.GETTERS.PARAMETER_COUNT_OPTIONS]()
            },
            parameterSubjectCountOptions: function() {
                return this.$store.getters[this.$const.GETTERS.PARAMETER_SUBJECT_COUNT_OPTIONS]()
            },
            queueTypeOptions: function() {
              return this.$store.getters[this.$const.GETTERS.QUEUE_TYPE_OPTIONS]()
            },
        },
        methods: {
            resizeHandler: function() {
                this.modalHeight = window.innerHeight - 300
                this.modalWidth = window.innerWidth -150
            },
            send:function() {
                this.setparamSubjectCnt();
                if(this.isCreatModal) {
                    if(!this.validationCheck()) return;
                    api.isExistEventId().then((result)=>{
                        if(!result) return
                        let events = result.data.content.content
                        if(events.filter(value=> value.eventId === this.eventTypeData.eventId).length > 0) {
                            this.$notify.alert('Event Id is exist');
                            return;
                        }
                        if(!this.validationCheck()) return;
                        this.save()
                    })
                } else {
                    if(!this.validationCheck()) return;
                    this.save()
                }
            },
            save: function() {
                if(this.isCreatModal) {
                    if(this.isCopy) {
                        // copy
                        this.eventTypeData.fromEventId = this.view.eventId
                    } else {
                        // create
                        this.eventTypeData.eventId = this.view.eventId
                    }
                }
                api.saveEventType(this.eventTypeData).then((result)=>{
                    if(result && result.data.code === 1000) {
                        this.$notify.success('Saved')
                        $("#"+this.target).modal('toggle')
                        this.$parent.search()
                    } else {
                        this.$notify.alert('Fail to save')
                    }
                })
            },
            setEventTypeData: function(data,flag) {
                this.eventTypeData = $.extend({},data)
                this.view.eventId = this.eventTypeData.eventId
                this.isCreatModal = flag  //create modal or update modal
            },
            setparamSubjectCnt: function (){
                if(this.eventTypeData.addParamSubjYn === "N"){
                    this.eventTypeData.paramSubjectCnt = 0
                }
            },
        },
    }
</script>

<style scoped>
    .modal-header .close {
        top:4% !important;
    }
    .modal-header {
        padding: 9px 19px !important;
    }
</style>
